export interface IIconProps {
  className: string;
}

function HeartOutline({ className }: IIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17.505"
      viewBox="0 0 20 17.505"
      className={className}
    >
      <path
        fill="#03468c"
        d="M17.906-14.988A5.884 5.884 0 0010-14.4a5.88 5.88 0 00-7.906-.586 5.91 5.91 0 00-.414 8.638L8.531.633A2.048 2.048 0 0010 1.254a2.038 2.038 0 001.469-.617l6.852-6.98a5.915 5.915 0 00-.415-8.645zm-.922 7.324l-6.851 6.98a.161.161 0 01-.266 0l-6.851-6.98a4.028 4.028 0 01.284-5.887 3.96 3.96 0 015.332.41L10-11.746l1.367-1.395a3.958 3.958 0 015.332-.414 4.046 4.046 0 01.285 5.891z"
        data-name="Tracé 3324"
        opacity="0.5"
        transform="translate(0 16.251)"
      ></path>
    </svg>
  );
}

export default HeartOutline;
